// src/firebase.js
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
  sendPasswordResetEmail // <-- Moved import here
} from 'firebase/auth';
// Import Firestore functions if needed directly here, or use async import
// import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCO3vQAd9wisBhJ4u1BJN1VRPQQe7SitEs",
  authDomain: "ccm-viewer.firebaseapp.com",
  projectId: "ccm-viewer",
  storageBucket: "ccm-viewer.firebasestorage.app",
  messagingSenderId: "208895869607",
  appId: "1:208895869607:web:94eecc798fcada8ed09182",
  measurementId: "G-F495LZRF65"
};


// CORRECT ORDER

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Auth once and export it FIRST
export const auth = getAuth(app);

// Asynchronously load Firestore only when needed
// This is good practice if Firestore isn't always needed immediately
//
// Plain in-memory cache (getFirestore), no IndexedDB persistence.
// persistentLocalCache was tried 2026-08-25 to cut redundant reads across
// reloads, but its IndexedDB-backed local cache produced a same-day
// DataCloneError / "INTERNAL ASSERTION FAILED (ID: b815)" on
// updateTargetData (2026-08-26) that wedged the whole persistence layer and
// made every record save fail with a misleading "check your connection"
// toast. Switching persistentMultipleTabManager -> persistentSingleTabManager
// did not fix it -- the trigger is IndexedDB persistence itself on this SDK
// version (12.3.0), not the multi-tab coordination path specifically. Do not
// re-enable persistentLocalCache without first confirming that underlying
// SDK issue is resolved.
export async function getFirebaseServices() {
  const { getFirestore } = await import('firebase/firestore');
  const db = getFirestore(app);
  return { db, auth };
}

// --- Define sendPasswordReset BEFORE authHelpers ---
export const sendPasswordReset = (email) => {
  // --- Use the existing 'auth' constant ---
  return sendPasswordResetEmail(auth, email);
};

// NOW, define authHelpers, which can safely use the 'auth' constant
export const authHelpers = {
  auth: auth, // Exporting 'auth' directly might be sufficient
  provider: new GoogleAuthProvider(),
  signIn: () => signInWithPopup(auth, authHelpers.provider), // Use provider from within authHelpers
  signInWithEmail: (email, password) => { // Removed unnecessary async/await
    return signInWithEmailAndPassword(auth, email, password);
  },
  logOut: () => signOut(auth),
  onAuth: (cb) => onAuthStateChanged(auth, cb),
  sendPasswordReset, // Now correctly references the function defined above
};

// Set custom parameters AFTER provider is defined within authHelpers
authHelpers.provider.setCustomParameters({
  prompt: 'select_account'
});
